import getVariant from "./getVariant";

const getSubtotal = ({ cart = {}, variants = [], type }) => {
  const items = Array.isArray(cart.items) ? cart.items : [];

  let subtotalInCents = 0;

  items
    .filter(item => !type || item.type === type)
    .forEach(item => {
      const variant = variants.find(v => getVariant(v, item));
      if (variant) {
        const qty = item.qty || item.quantity || 1;
        subtotalInCents += variant.retail * 100 * qty;
      }
    });

  return (subtotalInCents / 100).toFixed(2);
};

export default getSubtotal;
